#import "../../../graphql/fragments/email-membership-stats-fragment.graphql"

# Just membership stats information about an audience

fragment AudienceMembershipStats on Audience {
    id
    membershipStats {
        ...EmailMembershipStatsFragment
    }
}
